// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__2zLzI","loader":"ContentLoader_loader__2__Vj","disabled":"ContentLoader_disabled__3fKu5"};